import React from "react";
import FontAwesome from "react-fontawesome";

const PermitList = ({ list }) => {

  return (
    <div>
      {list && list.length > 0 && (
        <div>
          <div className="container-fluid">
            <div className="row" style={{ fontSize: "14px" }}>
            <div className="col-lg-4  col-sm-6 col-xs-12">
                <span className="font-weight-normal"
                 className="badge bg-secondary"
                 style={{ fontSize: "14px" }}
                >
                  {" "}
                  ได้รับเงินจากคุณ : {list.length > 0 && list[0].name}{" "}
                  {list.length > 0 && list[0].lname}{" "}
                </span>
              </div>


              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  วันที่ โอน: {list.length > 0 && list[0].uploaddate}
                </p>
              </div>
              
              <div className="col-lg-4  col-sm-6 col-xs-12">
                {/* {
                  <span
                    className="badge bg-success"
                    style={{ fontSize: "14px" }}
                  >
                    เลขที่เอกสาร:{list.length > 0 && list[0].payno}
                  </span>
                } */}
                {
                  <span
                    className="badge rounded-pill bg-primary"
                    style={{ fontSize: "14px" }}
                  >
                    {" Zone:"} {list.length > 0 && list[0].parkname}
                  </span>
                }
              </div>
            </div>
            {/* <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  ทะเบียนรถ: {list.length > 0 && list[0].car}
                </p>
              </div>

              { list.length > 0 && <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  ประเภท:{list.length > 0 && list[0].cartype}
                </p>
              </div>}
              <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  สี:{list.length > 0 && list[0].color} {list.DepartmentName}{" "}
                </p>
              </div>
            </div> */}

            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  ชำระเดือน: {list.length > 0 && list[0].payfrom}
                </p>
              </div>

              <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  ถึง: {list.length > 0 && list[0].payto}
                </p>
              </div>
              <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  รวม: {list.length > 0 && list[0].totalmonth} {" เดือน"}
                </p>
              </div>
            </div>


            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  ชำระ: {list.length > 0 &&  (list[0].rate * list[0].totalmonth ) } บาท
                </p>
              </div>

              <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                ค่าปรับ{ list[0].totalpay - (list[0].rate * list[0].totalmonth ) } บาท
                </p>
              </div>
              <div className="col-lg  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  รวม:{list.length > 0 && list[0].totalpay} บาท
                </p>
              </div>
            </div>

         
         


           
          </div>
        </div>
      )}
    </div>
  );
};

export default PermitList;
